// extracted by mini-css-extract-plugin
module.exports = {"news":"list_news__12tr3"};